<template>
  <v-container>
    <v-row>
      <v-col md="6">
        <v-card
          class="mx-auto text-center"
          color="primary"
          dark
          max-width="600"
        >
          <v-card-text>
            <v-sheet color="rgba(0, 0, 0, .12)">
              <v-sparkline
                :value="value"
                color="rgba(255, 255, 255, .7)"
                height="100"
                padding="24"
                stroke-linecap="round"
                smooth
              >
                <template v-slot:label="item"> ${{ item.value }} </template>
              </v-sparkline>
            </v-sheet>
          </v-card-text>



          <v-divider></v-divider>

          <v-card-actions class="justify-center">
            <v-btn block text> Go to Report </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col md="6">
        <v-card class="mx-auto text-center" color="primary" dark max-width="600">
          <v-card-text>
            <v-sheet color="rgba(0, 0, 0, .12)">
              <v-sparkline
                :value="value1"
                color="rgba(255, 255, 255, .7)"
                height="100"
                padding="24"
                stroke-linecap="round"
                smooth
              >
                <template v-slot:label="item"> ${{ item.value }} </template>
              </v-sparkline>
            </v-sheet>
          </v-card-text>



          <v-divider></v-divider>

          <v-card-actions class="justify-center">
            <v-btn block text> Go to Report </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="12">
        <v-card elevation="5" color="primary">
          <v-sparkline
            :value="value2"
            :gradient="gradient"
            :smooth="radius || false"
            :padding="padding"
            :line-width="width"
            :stroke-linecap="lineCap"
            :gradient-direction="gradientDirection"
            :fill="fill"
            :type="type"
            :auto-line-width="autoLineWidth"
            auto-draw
          ></v-sparkline>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
const gradients = [
  ["#222"],
  ["#42b3f4"],
  ["red", "orange", "yellow"],
  ["purple", "violet"],
  ["#00c6ff", "#F0F", "#FF0"],
  ["#51a344", "#ffd200", "#f72047"],
];

export default {
  data: () => ({
    width: 2,
    radius: 10,
    padding: 8,
    lineCap: "round",
    gradient: gradients[5],
    value: [5, 2, 5, 9, 5, 10, 3, 5, 0, 8, 2, 9, 0, 1, 6],
    value1: [3, 5, 0, 0, 1, 2, 5, 9, 8, 2, 9, 6, 0, 5, 10],
    value2: [1 , 2 ,1 , 3 ,1 , 4 ,1 , 5 ,1 , 6 ,1 , 7 ,1 , 8 ,1 , 9 ,1 , 10 ,1 , 10 ],
    gradientDirection: "top",
    gradients,
    fill: false,
    type: "trend",
    autoLineWidth: false,
    speed : 0
  }),
};
</script>

